import { client } from "./client";

export const uploadFile = async (path: string, file: File) => {
  const formData = new FormData();
  console.log("Upload path:", path);
  console.log("Upload file:", file);

  // 파일 정보 생성
  const message = {
    id: "",
    file_info: {
      // file_name: file.name,
      file_path: `/data1/datasets${path}/${file.name}`,
      file_type: "image",
    },
  };

  formData.append("files", file);
  formData.append("messages", JSON.stringify(message));

  // path를 query parameter로 전달
  const response = await client.post(`/upload?path=/data1/datasets${path}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const getImgData = async (ip: string, uuid: string, isMulti: boolean, viewMode: string) => {
  try {
    const response = await client.get(`/ai/images`, {
      params: { ip, uuid, isMulti, viewMode },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
